// @flow
// noinspection JSUnresolvedVariable

import React, { useState } from 'react';
import { Link, useHistory, useParams } from "react-router-dom";
import {
    WerfenColor, WerfenColor4, White
} from '../../../../Constants/ColorChart';
import { BackendURL, GraphQLURL, RECENT_INTERVAL } from "../../../../Constants/AppData";
import {
    hexToRgbA,
    triggerItemAnalytics,
    triggerItemDownloadAnalytics,
    triggerItemStoreAnalytics,
    triggerPDFViewerAnalytics,
    triggerStreamViewerAnalytics
} from '../../../../Utils/utils'
import getMediaDownloadToken from "../../../FileDownload/GetMediaDownloadToken";
import { setDocument } from "../../../../../actions/documentViewer";
import { connect } from "react-redux";
import { hideModalBokecc, showDialog, showModalBokecc } from "../../../../../actions/ui";
import {
    addPlaylistToDownloadQueue,
} from '../../../../../actions/downloadManager';
import FeatherIconWrapper from "../../../Icons/FeatherIconWrapper";
import PlaylistIcon from "../../../Icons/Playlist/Playlist";
import ResourceIcon from "../../../Icons/Resource/Resource";
import RecentIcon from "../../../Icons/Recent/Recent";
import SquarePlusIcon from "../../../Icons/SquarePlus/SquarePlus";
import SquareMinusIcon from "../../../Icons/SquareMinus/SquareMinus";
import ViewIcon from "../../../Icons/View/View";
import StreamIcon from "../../../Icons/Stream/Stream";
import VersionsIcon from "../../../Icons/Versions/Versions";
import AvailableOfflineIndicator from "../../../AvailableOfflineIndicator/AvailableOfflineIndicator";
import DownloadIcon from "../../../Icons/Download/Download";
import LikeIcon from "../../../LikeIcon/LikeIcon";
import LinkIcon from "../../../Icons/Link/Link";
import TrashIcon from "../../../Icons/Trash/Trash";
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import "./ResultRow.css";
import isElectron from 'is-electron'
import Checkbox_Check from "../../../Icons/Checkbox/Checkbox_Check";
import Checkbox_Empty from "../../../Icons/Checkbox/Checkbox_Empty";
import Exclamation from '../../../Icons/Exclamation/Exclamation';
import ReportErrorModal from '../../../ReportErrorForm/ReportErrorModal';
import useWindowDimensions from "../../../Sensors/useWindowDimensions";
import {
    PictureAndTextDiv,
    ClickableDiv,
    IconContainer,
    RowNameContainer,
    RowName,
    TableRow,
    TableData,
    StyledName,
    StyledBadge,
    StyledExtLinkBadge,
    StyledBokeccVideoBadge
} from "./StyledResultRow";
import { ResultRowDescription } from "./ResultRowDescription";
import { ResultRowTags } from "./ResultRowTags";

let electron;
if ( isElectron () ) {
    electron = window.require ( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

const ResultRow = ( props ) => {
    const { windowWidth } = useWindowDimensions ();
    const laptopFormat = windowWidth < 1200 && windowWidth > 1050;
    const tabletFormat = windowWidth < 1050 && windowWidth > 992;
    const mobileFormat = ( ( navigator.userAgent.indexOf ( 'IEMobile' ) !== -1 ) || ( windowWidth < 992 ) );
    const verticalMobileFormat = ( ( navigator.userAgent.indexOf ( 'IEMobile' ) !== -1 ) || ( windowWidth < 768 ) );
    const [ isDescriptionOpen, setIsDescriptionOpen ] = useState ( false );
    const [ isModalOpen, setModalOpen ] = useState ( false );
    const [ currentRow, setCurrentRow ] = useState ( null );
    const {
        isNetworkAvailable,
        row,
        rowId,
        fieldsToShow,
        index,
        sapFile,
        bokeccVideo,
        setSelectedForDownload,
        sendPlaylistDownloadRequest,
        externalLink,
        tableUnified,
        userSalesOrgs,
        userRoles,
        session
    } = props;
    const tags = row.metadata.tags
    const history = useHistory ();
    let id = useParams ().id
    const canConnect = isNetworkAvailable //&& isServerReachable;
    const canSeeReportIcon = ( userSalesOrgs.includes ( "193" ) && userRoles.includes ( "service_internal" ) && process.env.REACT_APP_SEE_SERVICE_ERROR_REPORTING === "1" )
    const keywordExists = tags && tags.length > 0
    const rowIdInteger = parseInt(row.id);
    const isDownloadingPlaylist = props.downloadManager.playlistDownloadQueue.includes(row.id);
    const isDownloadingInQueue = props.download.documents.filter(document => document.getResourceId() === rowIdInteger && document.isDownloadingStatus()).length > 0;
    const playlistIsDownloading = row.isDownloading || isDownloadingPlaylist;
    const resourceIsDownloading = row.isDownloading || isDownloadingInQueue;
    const resourceIsActive = row.actions && row.actions.isDownloaded && !resourceIsDownloading;

    const handleDescriptionClick = ( event ) => {
        event.preventDefault ();
        event.stopPropagation ();
        setIsDescriptionOpen ( !isDescriptionOpen );
    }

    const showDialog = ( data ) => {
        props.showDialog ( data );
    }

    const openViewer = ( event, doc, tableType ) => {
        event.preventDefault ();
        event.stopPropagation ();
        let itemIndex;
        if ( tableType === "resource_detail" ) {
            itemIndex = doc.metadata.fileIndex
        }
        const data = {
            id: doc.id, itemIndex, name: doc.metadata.name
        }

        if ( canConnect && !tableType.includes ( "available_offline" ) ) {
            triggerPDFViewerAnalytics ( data, props.session.user );
            getMediaDownloadToken ( doc.media_uuid, props.session.token, ( mediaDownloadToken ) => {
                if ( mediaDownloadToken && mediaDownloadToken !== "null" ) {
                    doc.file = doc.url + '/' + mediaDownloadToken;
                    props.setDocument ( doc );
                } else {
                    showDialog ( {
                        dialogTitle: "Resource Unavailable",
                        dialogBody: [ "The resource ", doc.metadata.name, " isn't available!" ],
                    } )
                }
            } )
                .catch ( error => {
                    console.error ( "'getMediaDownloadToken' error in 'openViewer': ", error )
                } )
        } else {
            props.setDocument ( doc );
        }
    }

    const openStream = ( event, doc ) => {
        event.preventDefault ();
        event.stopPropagation ();
        const options = { "modalTitle": doc.metadata.name, "modalBody": doc.vIframe };
        const data = {
            id: doc.id, name: doc.metadata.name
        }
        if ( canConnect ) {
            triggerStreamViewerAnalytics ( data, props.session.user );
        }
        props.showModalBokecc ( options );
    }

    const openItemDetails = ( event, data ) => {
        event.preventDefault ();
        const { id, type } = data;
        history.push ( "/" + type + "/" + id );
        if ( canConnect ) {
            triggerItemAnalytics ( data, props.session.user )
        }
    }

    const showShareLink = ( event, doc, linkClass ) => {
        event.preventDefault ();
        event.stopPropagation ();

        const clickedLink = document.querySelectorAll ( "#link-" + linkClass )[0];
        if ( document.querySelectorAll ( "#link-" + linkClass )[0].classList.contains ( "d-none" ) ) {
            const shownLinks = document.querySelectorAll ( ".show" );
            const headerLinks = document.querySelectorAll ( '.ShareLink.show' );

            if ( shownLinks.length > 0 ) {
                shownLinks.forEach ( ( element ) => {
                    element.classList.remove ( "show" );
                    element.classList.add ( "d-none" );
                } )
            }
            if ( headerLinks.length > 0 ) {
                headerLinks.forEach ( ( element ) => {
                    element.classList.remove ( "show" );
                    element.classList.add ( "d-none" );
                } )
            }

            clickedLink.classList.add ( "show" );
            clickedLink.classList.remove ( "d-none" );

        } else {

            clickedLink.classList.add ( "d-none" );
            clickedLink.classList.remove ( "show" );

        }

        const inputLink = document.querySelectorAll ( "#input-" + linkClass )[0];
        inputLink.focus ();
        inputLink.select ();
        inputLink.setSelectionRange ( 0, 99999 ); /*For mobile devices*/
        document.execCommand ( "copy" );

    }

    const storeResource = (resource) => {
        resource.sessionToken = props.session.token;
        ipcRenderer.invoke('CreateResource', resource);

        if (canConnect) {
            const info = {
                id: resource.id,
                name: resource.metadata.name,
                type: resource.type,
                index: resource.metadata.fileIndex
            };
            triggerItemStoreAnalytics(info, props.session.user);
        }
    }

    const getStreamText = () => {
        // TODO: Define multilingual strategy, set available languages for app by SalesOrg.
        const salesOrg = ( props.settings && props.settings.salesOrganizations && props.settings.salesOrganizations[0] )
        if ( salesOrg === "Werfen China (167)" || salesOrg === "Werfen China (167)" ) {
            return "视频流";
        } else {
            return "STREAM";
        }
    }

    const GetPlaylistData = async ( id ) => {

        const query = JSON.stringify ( {
            query: `
                query PlaylistById($id: String!){
                    nodeById(id: $id) {
                        ... on NodePlaylist {
                            uuid
                            entityChanged
                            nid
                            title
                            fieldPlaylistDescription
                            fieldPlaylistItemsCount
                            entityType
                            isLikedByCurrentUser
                            fieldPlaylistImportedFromSap
                            fieldPlaylistTabs {
                                entity {
                                    ... on LayoutTab {
                                        title		
                                        id
                                        uuid
                                        fieldTabItems {
                                            entity {
                                                entityType
                
                                                ... on NodeResource {
                                                    uuid
                                                    entityChanged
                                                    entityCreated
                                                    nid
                                                    title
                                                    entityId
                                                    entityLabel
                                                    entityType
                                                    fieldResourceDescription
                                                    fieldResourceFromDate
                                                    fieldResourceReleaseDate
                                                    isLikedByCurrentUser
                                                    fieldResourceOfflinePeriod {
                                                        targetId
                                                    }  
                                                    fieldResourceFilesByFormat {
                                                        entity {
                                                            ... on Media {
                                                                uuid
                                                                entityChanged
                                                                entityCreated
                                                                name
                                                                mid
                                                                entityLabel
                                                                entityType
                                                                entityBundle
                                                                entityId
                                                                uuid
                                                                bundle {
                                                                    targetId
                                                                }
                                                            }
                
                                                            ... on MediaMediaFile {
                                                                fieldMediaFileLanguage {
                                                                    value
                                                                }
                
                                                                fieldMediaFile {
                                                                    entity {
                                                                        ... on File {
                                                                            uuid
                                                                            entityChanged
                                                                            entityCreated
                                                                            entityId
                                                                            url
                                                                            filesize
                                                                            filemime
                                                                            filename
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            ... on MediaSapFile {
                                                                uuid
                                                                entityChanged
                                                                entityCreated
                                                                entityId
                                                                fieldSapFromDate
                                                                fieldSapReleaseDate
                                                                fieldSapFileLanguage {
                                                                    value
                                                                }
                                                                fieldSapFileFileSize
                                                                fieldSapFileFileName
                                                                fieldSapFileDocumentVersion
                                                                fieldSapFileMime
                                                                fieldSapFileFileExtension {
                                                                    entity {
                                                                        ... on TaxonomyTermFileExtension {
                                                                            fieldFileExtensionValue
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            ... on MediaMasterControl {
                                                               uuid
                                                               entityChanged
                                                               entityId
                                                               fieldMasterControlId
                                                               fieldMasterControlCategory
                                                               fieldMasterControlDescription
                                                               fieldMasterControlTitle
                                                               fieldMasterControlRevision
                                                               fieldMasterControlMime
                                                               fieldMasterControlSize
                                                               fieldMasterControlExtension {
                                                                entity {
                                                                  ... on TaxonomyTermFileExtension {
                                                                    fieldFileExtensionValue
                                                                  }
                                                                }
                                                               }
                                                            }
                                                            ... on MediaMasterControlAttachment {
                                                               uuid
                                                               entityChanged
                                                               entityId
                                                               fieldMcAttachmentId
                                                               fieldMcAttachmentName
                                                               fieldMcAttachmentDescription
                                                               fieldMcAttachmentMime
                                                               fieldMcAttachmentSize
                                                               fieldMcAttachmentExtension {
                                                                entity {
                                                                  ... on TaxonomyTermFileExtension {
                                                                    fieldFileExtensionValue
                                                                  }
                                                                }
                                                               }
                                                            }
                                                            ... on MediaBokeccVideo {
                                                                fieldBokeccIframe
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `, variables: {
                "id": String(id)
            }
        } );
        let myHeaders = new Headers ();
        const URL = `${ GraphQLURL }/graphql`;

        myHeaders.append ( "Content-Type", "application/json" );
        myHeaders.append ( "Authorization", "Bearer " + window.localStorage.getItem ( 'token' ) );

        const requestOptions = {
            method: 'POST', headers: myHeaders, body: query, redirect: 'follow'
        };
        return await fetch ( URL, requestOptions );
    }

    const storePlaylist = ( playlist ) => {
        props.addPlaylistToDownloadQueue ( playlist.id );

        GetPlaylistData ( playlist.id )
            .then ( ( result ) => {
                return result.json ()
            } )
            .then ( ( response ) => {
                if ( response.error ) {
                    console.error ( "Error in response for 'playlistQuery' in 'storePlaylist': ", response.error )
                } else {
                    const playlistData = response.data.nodeById;

                    const info = {
                        id: playlistData.nid, name: playlistData.title, type: "playlist"
                    }
                    props.addItemToQueue ( info );

                    const playlistExtendedData = { ...playlistData, backendURL: BackendURL }

                    ipcRenderer.send ( "storePlaylistMetadata", playlistExtendedData );

                    triggerItemStoreAnalytics ( info, props.session.user )
                }
            } )
            .catch ( ( error ) => {
                console.error ( "Error in 'storePlaylist': ", error );
            } );
        return false;
    }

    const openOfflineItemDetail = ( event, id, type ) => {
        event.preventDefault ();
        event.stopPropagation ();
        let slug = "/offlinePlaylist/"
        if ( type === "resource" ) {
            slug = "/offlineResource/"
        }
        history.push ( slug + id )
    }

    const tableType = props.type;
    const locationOrigin = isElectron () ? process.env.REACT_APP_SITE_URL : window.location.origin
    let showControls = true;

    let shareLink = locationOrigin + "/link/" + row.id
    let linkClass = row.id
    if ( tableType === "resource_detail" ) {
        if (id === undefined) {
            id = row.id;
        }
        shareLink = locationOrigin + "/link/" + id + "/" + row.metadata.fileIndex
        linkClass = row.id + "-" + row.metadata.fileIndex;
    }
    if ( tableType === "available_offline" && row.metadata.needs_attention ) {
        showControls = false
    }

    const handleReportError = ( row ) => {
        setCurrentRow ( row );
        setModalOpen ( true );
    }

    const handleCloseModal = () => {
        setModalOpen ( false );
        setCurrentRow ( null );
    }


    return ( <React.Fragment>
            <TableRow
                id={ rowId }
                className={ ( index % 2 === 0 ? "even" : "odd" ) + " " }
            >
                { row.type === "resource" && <TableData className={ "checkbox" }>
                    <FeatherIconWrapper
                        color={ WerfenColor }
                        fillColor={ "none" }
                        width={ "24px" }
                        onClick={ () => ( setSelectedForDownload ( row ) ) }
                        Icon={ props.requestIncludesMe ? Checkbox_Check : Checkbox_Empty }/>
                </TableData> }
                { fieldsToShow && fieldsToShow.map ( ( field ) => {
                    return row && row.metadata && Object.entries ( row.metadata ).map ( ( [ key, value ] ) => {
                        let mustProceed = false;
                        if ( key === field ) {
                            mustProceed = true;
                        }

                        if ( mustProceed ) {
                            let output;
                            switch ( key ) {
                                case "type":
                                    output = <IconContainer
                                        className={ "iconContainer" }
                                        data-title={ "Type" }
                                    >
                                        <FeatherIconWrapper
                                            color={ WerfenColor }
                                            fillColor={ "none" }
                                            width={ "30px" }
                                            Icon={ value === "playlist" ? PlaylistIcon : ResourceIcon }/>
                                    </IconContainer>
                                    break;
                                case "name":
                                case "title":
                                case "filename":
                                    const now = Date.now ();
                                    output = <PictureAndTextDiv
                                        style={ { width: tableUnified ? "20vw" : 'auto' } }
                                    >
                                        { ( now - row.metadata.lastVerified < RECENT_INTERVAL ) && <FeatherIconWrapper
                                            fillColor={ WerfenColor }
                                            color={ WerfenColor }
                                            width="12px"
                                            iconStyle="display: inline-block; stroke-width: 1px; width: 18px;height: 18px; margin-top: 2px; vertical-align: text-bottom; padding: 0; overflow: visible!important; position: absolute; left: -12px; top: -8px;"
                                            Icon={ RecentIcon }
                                        /> }
                                        { tableUnified ?
                                            <StyledName>{ decodeURIComponent ( value ) }</StyledName> : decodeURIComponent ( value ) }

                                        { sapFile && <StyledBadge sapBadge={ true }
                                                                  bsPrefix="badge badge-info badge-small">SAP</StyledBadge> }

                                        { bokeccVideo && <StyledBokeccVideoBadge
                                            bsPrefix="badge badge-info badge-small">{ getStreamText () }</StyledBokeccVideoBadge> }
                                        { externalLink && <StyledExtLinkBadge
                                            bsPrefix="badge badge-info badge-small">ExtLink</StyledExtLinkBadge> }
                                    </PictureAndTextDiv>;
                                    break;
                                case "status":
                                    output = <RowNameContainer uniqueRowText={ fieldsToShow.length === 1 }>
                                        <RowName uniqueRowText={ fieldsToShow.length === 1 }>
                                            { index === 0 ? row.metadata.status : value }
                                        </RowName>
                                    </RowNameContainer>

                                    break;
                                case "size":
                                    if ( mobileFormat || tabletFormat ) {
                                        output = null;
                                    } else {
                                        output = <RowNameContainer className={ key }
                                                                   laptopFormat={ laptopFormat }
                                                                   tableUnified={ tableUnified }
                                                                   uniqueRowText={ fieldsToShow.length === 1 }>
                                            <RowName
                                                uniqueRowText={ fieldsToShow.length === 1 }>{ value }</RowName>
                                        </RowNameContainer>
                                    }
                                    break;
                                case "section":
                                    output = <RowNameContainer className={ key }
                                                               style={ { width: "11vw" } }
                                                               uniqueRowText={ false }>
                                        <RowName
                                            uniqueRowText={ false }>{ value }</RowName>
                                    </RowNameContainer>
                                    break;
                                case "created":
                                case "updated":
                                    if ( verticalMobileFormat ) {
                                        output = null;
                                    } else {
                                        output = <RowNameContainer className={ key }
                                                                   style={ {
                                                                       width: tabletFormat ? "10vw" : mobileFormat ? "11vw" : "9vw",
                                                                       paddingRight: tabletFormat ? "8px" : mobileFormat ? "8px" : "0"
                                                                   } }
                                                                   uniqueRowText={ false }>
                                            <RowName
                                                uniqueRowText={ false }>{ value }</RowName>
                                        </RowNameContainer>
                                    }
                                    break;
                                default:
                                    output = <RowNameContainer uniqueRowText={ fieldsToShow.length === 1 }>
                                        <RowName
                                            uniqueRowText={ fieldsToShow.length === 1 }>{ decodeURIComponent ( value ) }</RowName>
                                    </RowNameContainer>
                            }

                            if ( output !== null ) {

                                const canShowPointer = showControls
                                  && row
                                  && (
                                    row.metadata.entityBundle === "external_link"
                                    || row.metadata.entityBundle === "bokecc_video"
                                    || row.type === "playlist"
                                    || (
                                      row.activities
                                      && row.activities.canOpenInViewer
                                      && !mobileFormat
                                      && !bokeccVideo )
                                    || (
                                      row.activities
                                      && row.activities.canViewDetail
                                      && row.type === "resource" )
                                    || (
                                      row.saveAs
                                      && row.activities
                                      && row.activities.canDownload
                                      && row.type === "resource" )
                                    || row.defaultAction );

                                return ( <TableData
                                        key={ "key" + key }
                                        width={ ( key === "name" || key === "title" || key === "filename" ) ? "*" : ( key === "type" ) ? "30" : "10%" }
                                    >
                                        <ClickableDiv
                                            onClick={ ( event ) => {
                                                event.preventDefault();
                                                event.stopPropagation();

                                                if (!showControls || !row) {
                                                  return;
                                                }

                                                if (row.metadata.entityBundle === "external_link") {
                                                  window.open(row.externalLink, '_blank');
                                                  return;
                                                }

                                                if (row.metadata.entityBundle === "bokecc_video") {
                                                  openStream(event, row);
                                                  return;
                                                }

                                                if (row.type === "playlist" && tableType === "available_offline") {
                                                  openOfflineItemDetail(event, row.id, row.type);
                                                  return;
                                                }

                                                if (row.type === "playlist") {
                                                  openItemDetails(event, {
                                                    id: row.id,
                                                    title: row.metadata.title,
                                                    type: "Playlist"
                                                  });
                                                  return;
                                                }

                                                if (row.activities && row.activities.canOpenInViewer && !mobileFormat && !bokeccVideo) {
                                                  openViewer(event, row, tableType);
                                                  return;
                                                }

                                                if (row.activities && row.activities.canViewDetail && row.type === "resource" && tableType === "available_offline") {
                                                  openOfflineItemDetail (event, row.id, row.type);
                                                  return;
                                                }

                                                if (row.activities && row.activities.canViewDetail && row.type === "resource") {
                                                  saveAs(event, row, tableType, isNetworkAvailable, session);
                                                  return;
                                                }

                                                if (row.saveAs && row.activities && row.activities.canDownload && row.type === "resource") {
                                                  saveAs(event, row, tableType, isNetworkAvailable, session);
                                                  return;
                                                }

                                                if (row.defaultAction && row.metadata && row.metadata.mimetype && row.metadata.mimetype.toUpperCase() === "PDF" && mobileFormat) {
                                                  row.saveAs(event);
                                                  return;
                                                }

                                                if (row.defaultAction) {
                                                  row.defaultAction(event);
                                                }
                                            }}
                                            showPointer={ canShowPointer }
                                        >
                                            { output }

                                        </ClickableDiv>

                                    </TableData> )
                            } else {
                                return null;
                            }
                        }
                        return null;
                    } )
                } ) }

                { showControls && <TableData className="actions" width={ "*" } textAlignRight>
                    {/* DESCRIPTION */ }
                    { row && row.metadata && row.metadata.description && !props.settings.expandedByDefault &&
                      <IconContainer
                        className={ "iconContainer" }
                        data-title={ "Description" } >
                          <FeatherIconWrapper
                            color={ WerfenColor }
                            fillColor={ "none" }
                            width={ "30px" }
                            onClick={ ( event ) => ( handleDescriptionClick ( event ) ) }
                            Icon={ !isDescriptionOpen ? SquarePlusIcon : SquareMinusIcon }/>
                      </IconContainer> }

                    {/* TOGGLE DESCRIPTION */ }
                    { row && row.metadata && !row.metadata.description && !props.settings.expandedByDefault &&
                      <IconContainer
                        className={ "iconContainer" }
                        data-title={ "Description unavailable" }
                      >
                          <FeatherIconWrapper
                            color={ WerfenColor4 }
                            fillColor={ "none" }
                            width={ "30px" }
                            Icon={ !isDescriptionOpen ? SquarePlusIcon : SquareMinusIcon }/>
                      </IconContainer> }

                    {/* VIEWER (PDF) */ }
                    { row && row.activities && row.activities.canOpenInViewer && !mobileFormat && !bokeccVideo &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "View" } >
                            <FeatherIconWrapper
                                color={ WerfenColor }
                                fillColor={ "none" }
                                width={ "30px" }
                                onClick={ ( event ) => ( openViewer ( event, row, tableType ) ) }
                                Icon={ ViewIcon }

                            />
                        </IconContainer> }
                    { row && row.activities && !row.activities.canOpenInViewer && !mobileFormat && !bokeccVideo &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Not available to open online." } >
                            <FeatherIconWrapper
                                color={ WerfenColor4 }
                                fillColor={ "none" }
                                width={ "30px" }
                                Icon={ ViewIcon }/>
                        </IconContainer> }

                    {/* VIEWER (IFRAME VIDEO) */ }
                    { row && row.activities && row.activities.canOpenStream && !mobileFormat && bokeccVideo &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Can open stream" }
                        >
                            <FeatherIconWrapper
                                color={ WerfenColor }
                                fillColor={ "none" }
                                width={ "30px" }
                                onClick={ ( event ) => openStream ( event, row ) }
                                Icon={ StreamIcon }/>
                        </IconContainer> }
                    {/* DETAIL (RESOURCE) */ }
                    { row && row.activities && row.activities.canViewDetail && row.type === "resource" &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={"Multiple files"} >
                            <FeatherIconWrapper
                                color={ WerfenColor }
                                fillColor={ "none" }
                                width={ "30px" }
                                onClick={ ( event ) => {
                                    if ( tableType === "available_offline" || tableType === "available_offline_playlist" ) {
                                        openOfflineItemDetail ( event, row.id, row.type );
                                    } else {
                                        const data = {
                                            id: row.id, title: row.metadata.name, type: "Resource"
                                        }
                                        openItemDetails ( event, data )
                                    }
                                } }
                                Icon={ VersionsIcon }
                            />
                        </IconContainer> }
                    {/* EMPTY DETAIL (RESOURCE) */ }
                    { row && row.activities && !row.activities.canViewDetail && row.type === "resource" &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Single file" }
                        >
                            <FeatherIconWrapper
                                color={ WerfenColor4 }
                                fillColor={ "none" }
                                width={ "30px" }
                                Icon={ VersionsIcon }
                            />
                        </IconContainer> }

                    {/* DETAIL (PLAYLIST) */ }
                    { row && row.type === "playlist" && <IconContainer className={ "iconContainer" } data-title={ "Reproduce in playlist" }>
                        <FeatherIconWrapper
                            color={ WerfenColor }
                            fillColor={ "none" }
                            width={ "30px" }
                            onClick={ ( event ) => {
                                if ( tableType === "available_offline" ) {
                                    openOfflineItemDetail ( event, row.id, row.type );
                                } else {
                                    const data = {
                                        id: row.id, title: row.metadata.title, type: "Playlist"
                                    }
                                    openItemDetails ( event, data )
                                }
                            } }
                            Icon={ PlaylistIcon }
                        />
                    </IconContainer> }

                    {/* DOWNLOAD PLAYLIST FOR OFFLINE (DESKTOP) */ }
                    { isElectron () && row && row.type === "playlist" && tableType !== "available_offline" &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Unavailable offline" }>
                            <AvailableOfflineIndicator
                                color={ WerfenColor }
                                fillColor={ White }
                                width={ "30px" }
                                activeStyle={ `fill: ${ WerfenColor }; stroke: ${ White }` }
                                unactiveStyle={ `fill: none; stroke: ${ WerfenColor }; cursor: pointer` }
                                transitionColors={ [ WerfenColor, hexToRgbA ( WerfenColor, 0.5 ) ] }
                                active={ row.actions && row.actions.isDownloaded }
                                onClick={ () => row.actions && !row.actions.isDownloaded && storePlaylist ( row ) }
                                itemId={ row.id }
                                isActive={ row.actions && row.actions.isDownloaded && !row.isDownloading }
                                isDownloading={ playlistIsDownloading }
                            />
                        </IconContainer> }
                    {/* DOWNLOAD RESOURCE FOR OFFLINE (DESKTOP) */ }
                    { isElectron () && row && row.actions && row.activities && row.activities.canDownload &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Download" } >
                            <AvailableOfflineIndicator
                                color={ WerfenColor }
                                fillColor={ White }
                                width={ "30px" }
                                activeStyle={ `fill: ${ WerfenColor }; stroke: ${ White }` }
                                unactiveStyle={ `fill: none; stroke: ${ WerfenColor }; cursor: pointer` }
                                transitionColors={ [ WerfenColor, hexToRgbA ( WerfenColor, 0.5 ) ] }
                                active={ row.actions && row.actions.isDownloaded }
                                onClick={ () => row.actions && !row.actions.isDownloaded && storeResource ( row ) }
                                itemId={ row.id }
                                isActive={ resourceIsActive }
                                isDownloading={ resourceIsDownloading }
                            />
                        </IconContainer> }

                    {/* RESOURCE SAVE AS (WEB) */ }
                    { row && row.saveAs && !bokeccVideo &&
                        <Link
                            to={ { pathname: row.url } }
                            onClick={ ( event ) => {
                                saveAs ( event, row, tableType, isNetworkAvailable, session )
                            } }
                        >
                            <IconContainer className={ "iconContainer" } data-title={"Download"}>
                                <FeatherIconWrapper
                                    color={ WerfenColor }
                                    fillColor={ "none" }
                                    width={ "30px" }
                                    Icon={ DownloadIcon }
                                />
                            </IconContainer>
                        </Link> }

                    {/* PLAYLIST REQUEST DOWNLOAD (WEB) */ }
                    { row && row.type === "playlist" &&

                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Download" } >
                            <FeatherIconWrapper
                                color={ WerfenColor }
                                fillColor={ "none" }
                                width={ "30px" }
                                onClick={ () => {
                                    sendPlaylistDownloadRequest ( row.id )
                                } }
                                Icon={ DownloadIcon }
                            />
                        </IconContainer> }

                    {/* LIKE/FAVORITE */ }
                    { row && row.actions && row.metadata && !row.metadata.entityBundle.includes("file") && tableType !== "available_offline" && tableType !== "available_offline_playlist" && tableType !== "available_offline_resource" &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Add to favorites" } >
                            <LikeIcon
                                color={ WerfenColor }
                                fillColor={ White }
                                width={ "30px" }
                                activeStyle={ `fill: ${ WerfenColor }; stroke: ${ White }` }
                                unactiveStyle={ `fill: none; stroke: ${ WerfenColor }` }
                                active={ row.actions.like }
                                itemId={ row.likeId }
                                likeId={ row.likeId }
                                itemName={ row.metadata.name ? row.metadata.name : row.metadata.title }
                                entityBundle={ row.metadata.entityBundle }
                                tableType={ tableType }
                            />
                        </IconContainer> }
                    {/* SHARE LINK */ }
                    { row && ( row.type === "playlist" || row.actions ) && ( history.location.pathname.indexOf ( "/link/" ) === -1 ) &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Share" }>
                            <div className="ShareLink d-none" id={ "link-" + linkClass }>
                                    <span className="ShareLink-close"
                                          onClick={ ( event ) => showShareLink ( event, row, linkClass ) }>✕</span>
                                <label
                                    className="ShareLink-title">{ row.type === "playlist" ? "Playlist " : row.type === "resource" ? "Resource " : "Resource File " }
                                    Link</label>
                                <input type="text" id={ "input-" + linkClass } value={ shareLink } readOnly/>
                                <small className={ "smallText" }>Link copied to your Clipboard!</small>
                            </div>
                            <FeatherIconWrapper
                                color={ WerfenColor }
                                fillColor={ "none" }
                                width={ "30px" }
                                onClick={ ( event ) => showShareLink ( event, row, linkClass ) }
                                Icon={ LinkIcon }
                            />
                            { canSeeReportIcon && ( <FeatherIconWrapper
                                    color={ "none" }
                                    fillColor={ "white" }
                                    width={ "30px" }
                                    onClick={ () => handleReportError ( row ) }
                                    Icon={ Exclamation }
                                    style={ { marginLeft: '5px' } }
                                /> ) }
                        </IconContainer> }
                    {/* DELETE RESOURCE */ }
                    { row && row.activities && tableType && tableType === "available_offline" && tableType !== "available_offline_playlist" &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Delete" }>
                            { row.activities.canDelete && <FeatherIconWrapper
                                color={ WerfenColor }
                                fillColor={ "none" }
                                width={ "30px" }
                                onClick={ ( event ) => {
                                    event.preventDefault ();
                                    event.stopPropagation ();
                                    showDialog ( {
                                        dialogTitle: "Deleting Resource",
                                        dialogBody: [ "This will delete the following resource:", row.metadata.name, "This action cannot be undone!" ],
                                        onAccept: {
                                            channel: "deleteResource", args: { resources: row.id }, goBack: null
                                        }
                                    } )
                                } }
                                Icon={ TrashIcon }
                            /> }
                            { ( !row.activities.canDelete ) && <span style={ {
                                "minWidth": "30px", "display": "inline-block"
                            } }> </span> }
                        </IconContainer> }
                    {/* DELETE PLAYLIST */ }
                    { row && row.type === "playlist" && tableType && tableType === "available_offline" &&
                        <IconContainer
                            className={ "iconContainer" }
                            data-title={ "Delete" }>
                            <FeatherIconWrapper
                                color={ WerfenColor }
                                fillColor={ "none" }
                                width={ "30px" }
                                onClick={ ( event ) => {
                                    event.preventDefault ();
                                    event.stopPropagation ();
                                    showDialog ( {
                                        dialogTitle: "Deleting Playlist",
                                        dialogBody: [ "This will delete the following playlist:", row.metadata.name, "This action cannot be undone!" ],
                                        onAccept: {
                                            channel: "deletePlaylist", args: row.id
                                        },
                                        goBack: null
                                    } )
                                } }
                                Icon={ TrashIcon }
                            />
                        </IconContainer> }
                </TableData> }

                { !showControls && <TableData width={ "*" } textAlignRight>
                    Please get back online to restore access
                </TableData> }

            </TableRow>

            { window.location.pathname !== '/resource' && row.metadata && row.metadata.description !== null && row.metadata.description !== undefined &&
               <ResultRowDescription
                   row={ row }
                   rowId={ rowId }
                   index={ index }
                   isDescriptionOpen={ isDescriptionOpen }
                   expandedByDefault={ props.settings.expandedByDefault }
               /> }

        { window.location.pathname !== '/resource' && keywordExists &&  < ResultRowTags
            row={ row }
            rowId = { rowId }
            index = { index }
            tags = { tags } />
            }

            { isModalOpen && ( <ReportErrorModal
                    currentRow={ row }
                    onClose={ handleCloseModal }
                /> ) }
        </React.Fragment> );

}

const mapStateToProps = ( state ) => ( {
    download: {
        documents: state.download.download,
    },
    downloadManager: {
        playlistDownloadQueue: state.downloadManager.playlistDownloadQueue
    },
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable,
    session: state.session,
    settings: state.settings,
} );

export const saveAs = ( event, doc, tableType, isNetworkAvailable, session ) => {
    event.preventDefault ();
    event.stopPropagation ();
    // noinspection UnnecessaryLocalVariableJS
    const canConnect = isNetworkAvailable // && isServerReachable;
    if ( canConnect && tableType !== "available_offline" ) {
        const info = { id: doc.id, name: doc.metadata.name, index: doc.metadata.fileIndex };
        triggerItemDownloadAnalytics ( info );
        getMediaDownloadToken ( doc.media_uuid, session.token, ( mediaDownloadToken ) => {
            if ( mediaDownloadToken !== null && mediaDownloadToken !== "null" ) {
                let link = document.createElement ( 'a' );
                // noinspection JSUndefinedPropertyAssignment
                link.download = doc.metadata.filename;
                // noinspection JSUndefinedPropertyAssignment
                link.href = doc.url + '/' + mediaDownloadToken;
                link.click ();
                link.remove ();
            } else {
                showDialog ( {
                    dialogTitle: "Resource Unavailable",
                    dialogBody: [ "The resource ", doc.metadata.name, " isn't available!" ],
                } )
            }
        } )
            .catch ( ( error ) => {
                console.error ( "Error with getMediaDownloadToken promise: ", error );
            } );
    } else {
        let link = document.createElement ( 'a' );
        // noinspection JSUndefinedPropertyAssignment
        link.download = doc.metadata.filename;
        // noinspection JSUndefinedPropertyAssignment
        link.href = doc.url;
        link.click ();
        link.remove ();
    }
}

export default connect ( mapStateToProps, {
    setDocument,
    showModalBokecc,
    hideModalBokecc,
    showDialog,
    addPlaylistToDownloadQueue,
} ) ( ResultRow );
